export const COIN_COUNT_VARIANT = {
  control: 0,
  alwaysHidden: 1,
  hiddenUnlessLowBalance: 2,
} as const

export const COIN_COUNT_LOW_THRESHOLD = 2500
